import { forwardRef, type CSSProperties, type HTMLAttributes } from "react";
import { cn } from "@/lib/cn";

export type GridProps = HTMLAttributes<HTMLDivElement> & {
  columns?: 1 | 2 | 3 | 4 | string;
  templateColumns?: string;
  minColumnWidth?: string;
  gap?: "sm" | "md" | "lg";
};

const columnsMap = {
  1: "bfrs-grid-cols-1",
  2: "bfrs-grid-cols-1 md:bfrs-grid-cols-2",
  3: "bfrs-grid-cols-1 md:bfrs-grid-cols-2 xl:bfrs-grid-cols-3",
  4: "bfrs-grid-cols-1 sm:bfrs-grid-cols-2 xl:bfrs-grid-cols-4"
};

const gapMap = {
  sm: "bfrs-gap-3",
  md: "bfrs-gap-5",
  lg: "bfrs-gap-6"
};

export const Grid = forwardRef<HTMLDivElement, GridProps>(({ className, columns = 3, templateColumns, minColumnWidth, gap = "md", style, ...props }, ref) => {
  const customTemplate = templateColumns ?? (typeof columns === "string" ? columns : undefined);
  const gridStyle: CSSProperties = {
    ...(customTemplate ? { gridTemplateColumns: customTemplate } : {}),
    ...(minColumnWidth ? { gridTemplateColumns: `repeat(auto-fit, minmax(${minColumnWidth}, 1fr))` } : {}),
    ...style
  };

  return (
    <div
      ref={ref}
      className={cn("bfrs-grid", typeof columns === "number" && !customTemplate && !minColumnWidth && columnsMap[columns], gapMap[gap], className)}
      style={gridStyle}
      {...props}
    />
  );
});

Grid.displayName = "Grid";
